<roma-mf-accounting-service
  [mode]="selectedPlan"
  [openPlans]="true"
  [isModal]="isModal"
  [updateReason]="updateReason"
  [fromUrl]="fromUrl"
></roma-mf-accounting-service>
